<template>
  <div>
    <autocomplete-multiple :name="name" :search-text.sync="searchText" :items="items" :select.sync="localSelect" :loading="loadState.isLoading"  v-bind="typeof selectAllEnabled !== 'undefined' ? { selectAllEnabled } : {}">
      <template v-slot:itemInfo="{item}">
        <v-row no-gutters class="caption">
          <v-col cols="auto">{{item.userProfile.gender==='male'?'Мужчина':'Женщина'}}</v-col>
          <v-col v-if="!$tools.isEmpty(item.userProfile.birth)" cols="auto"><dot/></v-col>
          <v-col v-if="!$tools.isEmpty(item.userProfile.birth)" cols="auto">{{$tools.dateYears(item.userProfile.birth,'YYYY-MM-DD')}}</v-col>
          <v-col cols="auto"><dot/></v-col>
          <v-col cols="auto">{{item.type==='admin' ? 'Администратор' : item.type==='spec' ? 'Специалист' : 'Клиент'}}</v-col>
        </v-row>
      </template>
      <template v-slot:appendOuter>
        <slot name="appendOuter"/>
      </template>
    </autocomplete-multiple>
  </div>

</template>

<script>
import State from "@/plugins/state";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";
import {
  Entity_User,
  Entity_UserProfile,
} from "../../../EntityStoreCacheService";
import Dot from "@/componentsV2/base/Dot.vue";
export default {
  components: {AutocompleteMultiple,Dot},
  props:[
    'name',
    'select',
    '_type',
    'selectAllEnabled'
  ],
  data:()=>({
    loadState: new State(),
    searchText: null,
    items:[],
    localSelect: null
  }),
  watch: {
    select() {
      this.localSelect = this.select;
      if(typeof this.localSelect!=='undefined') {
        this.localSelect.forEach(v=>{
          let found = false;
          this.items.forEach(v1=>{
            if(v.id===v1.id)
              found = true;
          })
          if(!found){
            v.name = this.$tools.userFullName(v)
            this.items.push(v)
          }
        })
      }
    },
    localSelect() {
      this.$emit('update:select', this.localSelect)
      //if data are received after mount
      if(typeof this.localSelect!=='undefined' && this.localSelect.length>0 && this.items.length===0) {
        this.localSelect.forEach(v=>{
          v.name = this.$tools.userFullName(v)
          this.items.push(v)
        });
      }
    },
    searchText(){
      this.$tools.debounce(()=>{
        this.load();
      });
    }
  },
  mounted() {
    this.localSelect = this.select;
    if(typeof this.localSelect!=='undefined' && this.localSelect.length>0) {
      let arr = [];
      this.localSelect.forEach(v=>{
        v.name = this.$tools.userFullName(v)
        arr.push(v)
      });
      this.items = arr;
    }
  },
  methods: {
    load() {
      let rb = new Entity_User()
      .selects(Entity_User.id)
      .selects(Entity_User.lastName)
      .selects(Entity_User.firstName)
      .selects(Entity_User.secondName)
      .selects(Entity_User.type)
      .selects([Entity_UserProfile.entity, Entity_UserProfile.birth].join('.'))
      .selects([Entity_UserProfile.entity, Entity_UserProfile.gender].join('.'))


      if (!this.$tools.isEmpty(this.searchText)) {
        let v = this.searchText.trim();
        if (/^\d+$/.test(v)&& v.length>0) { // id
          rb.filterAnd([Entity_User.entity, Entity_User.id].join('.') + ' =?', v)
        } else {
          let arr = v.split(' ');
          if (arr.length === 1 && arr[0][0] === '(') {//Для старой фамилии в скобках
            rb.filterAnd([Entity_User.entity, Entity_User.lastName].join('.') + ' LIKE ?', '%' + arr[0] + '%')
          } else if (arr.length === 1) {
            rb.filterAnd([Entity_User.entity, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
          } else if (arr.length === 2) {
            rb.filterAnd([Entity_User.entity, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
            rb.filterAnd([Entity_User.entity, Entity_User.firstName].join('.') + ' LIKE ?', arr[1] + '%')
          } else if (arr.length === 3) {
            rb.filterAnd([Entity_User.entity, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
            rb.filterAnd([Entity_User.entity, Entity_User.firstName].join('.') + ' LIKE ?', arr[1] + '%')
            rb.filterAnd([Entity_User.entity, Entity_User.secondName].join('.') + ' LIKE ?', arr[2] + '%')
          }
        }
      }
      
      if (this._type!==undefined)
        rb.filterAnd([Entity_User.entity, Entity_User.type].join('.') + ' =?', this._type)

      rb.addStateCallback((v) => {
        this.loadState.setRequestBuilderState(v)
      })
      .page(null)
      .request((v)=>{       
        let newItems = v.items.map(item => ({
          ...item,
          name: this.$tools.userFullName(item)
        }));

        newItems = this.items.concat(newItems);
        newItems = this.$tools.sortByKey(newItems)
        this.items = this.$tools.uniqueByKey(newItems)

      }, (e)=>{
        console.error(e.response.data.message);
      })  
    },
  }
}
</script>